/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Heading, IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import LinksComponent from './components/links';
import { IAbsoluteContentBlockSimpleProps} from './absolute-content-block-simple.props.autogenerated';

export interface IContentBlockSimpleViewProps extends IAbsoluteContentBlockSimpleProps<{}> {
    title?: React.ReactNode;
    text?: React.ReactNode;
    image?: React.ReactNode;
    links?: React.ReactNode;
    simpleLink?: string;
    className?: string;
    identifier?: string;
    contentBlockContainer: IModuleProps;
    imageContainer:INodeProps;
    detailsContainer:INodeProps;
}
/**
 *
 * ContentCard component
 * @extends {React.PureComponent<IAbsoluteContentBlockSimpleProps{}>}
 */

class ContentBlock extends React.PureComponent<IAbsoluteContentBlockSimpleProps<{}>> {
    public render(): JSX.Element | null {
        const { heading, paragraph, image, links, identifier, simpleLink, className} = this.props.config;
        const contentBlockTitle = heading && heading.text && <Heading className='absolute-content-block-simple__title' headingTag={heading.tag} text={heading.text} />;
        const imageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: image && image.imageSettings
        };
        const contentBlockLinks = links && links.length > 0 && <LinksComponent {...{ links }} />;
        const contentBlockText = paragraph && <Msdyn365.RichTextComponent text = {paragraph} className = 'absolute-content-block-simple__text' />;
        const contentBlockImage = image && <Msdyn365.Image {...image} {...imageProps} />;

        const SimpleLink = simpleLink ? simpleLink : '';

        if (!contentBlockTitle && !contentBlockText && !contentBlockImage && !contentBlockLinks) {
            return null;
        }

        const ContentBlockSimpleviewProps = {
            ...this.props,
            title: contentBlockTitle,
            text: contentBlockText,
            image: contentBlockImage,
            links: contentBlockLinks,
            simpleLink: SimpleLink,
            identifier: this.props.config.identifier,
            moduleClass: this.props.config.className,
            contentBlockContainer: {
                moduleProps: this.props,
                id: identifier,
                className: classnames('absolute-content-block-simple', className)
            },
            imageContainer: {className: 'absolute-content-block-simple__image'},
            detailsContainer: {className: 'absolute-content-block-simple__details'}
        };

        return this.props.renderView(ContentBlockSimpleviewProps) as React.ReactElement;
    }
}

export default ContentBlock;
